import { documents } from "@/mocks/documentos";
import DocumentStatusBadge from "./DocumentStatusBadge";

interface EnvironmentalSourcesTableProps {
  onViewDocument: (id: string) => void;
}

const areaDocs = documents.filter((d) =>
  d.primaryBindingType === "area" || d.primaryBindingType === "uc" || d.primaryBindingType === "compensation"
);

const areaLabelMap: Record<string, string> = {
  "Parque Municipal Buriti Sereno": "Parque",
  "Reserva Ecológica Buritis": "UC",
  "Área Verde Jardim América": "Área Verde",
  "APP Córrego Matinha": "APP Urbana",
  "Áreas Verdes Goiânia": "Área Verde",
  "Área Recuperada Industrial": "Área de Recuperação",
};

export default function EnvironmentalSourcesTable({ onViewDocument }: EnvironmentalSourcesTableProps) {
  return (
    <div className="space-y-4">
      <h3 className="text-sm font-semibold text-foreground-900">Documentos vinculados a áreas ambientais e UCs</h3>
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-background-200 text-left">
              <th className="py-3 px-3 text-xs font-semibold text-foreground-500 whitespace-nowrap">Área/Unidade</th>
              <th className="py-3 px-3 text-xs font-semibold text-foreground-500 whitespace-nowrap">Tipo</th>
              <th className="py-3 px-3 text-xs font-semibold text-foreground-500 whitespace-nowrap">Documento</th>
              <th className="py-3 px-3 text-xs font-semibold text-foreground-500 whitespace-nowrap">Órgão emissor</th>
              <th className="py-3 px-3 text-xs font-semibold text-foreground-500 whitespace-nowrap">Emissão</th>
              <th className="py-3 px-3 text-xs font-semibold text-foreground-500 whitespace-nowrap">Validade</th>
              <th className="py-3 px-3 text-xs font-semibold text-foreground-500 whitespace-nowrap">Status</th>
              <th className="py-3 px-3 text-xs font-semibold text-foreground-500 whitespace-nowrap">Ações</th>
            </tr>
          </thead>
          <tbody>
            {areaDocs.map((doc) => (
              <tr key={doc.id} className="border-b border-background-100 hover:bg-background-50/50 transition-colors">
                <td className="py-2.5 px-3">
                  <span className="text-sm font-semibold text-foreground-800">{doc.areaName || doc.primaryBinding}</span>
                </td>
                <td className="py-2.5 px-3">
                  <span className="text-xs text-foreground-500">{areaLabelMap[doc.primaryBinding] || "Outro"}</span>
                </td>
                <td className="py-2.5 px-3">
                  <button onClick={() => onViewDocument(doc.id)} className="text-sm font-medium text-foreground-800 hover:text-accent-600 transition-colors text-left max-w-[200px] truncate block">
                    {doc.title}
                  </button>
                </td>
                <td className="py-2.5 px-3 text-xs text-foreground-500 max-w-[150px] truncate">{doc.issuingBody}</td>
                <td className="py-2.5 px-3 text-xs text-foreground-500 whitespace-nowrap">{doc.issueDate}</td>
                <td className="py-2.5 px-3 text-xs text-foreground-500 whitespace-nowrap">{doc.expiryDate || "—"}</td>
                <td className="py-2.5 px-3"><DocumentStatusBadge status={doc.status} /></td>
                <td className="py-2.5 px-3">
                  <div className="flex items-center gap-1">
                    <button onClick={() => onViewDocument(doc.id)} className="w-7 h-7 rounded-md hover:bg-background-100 flex items-center justify-center text-foreground-500 hover:text-accent-600 transition-colors" title="Visualizar">
                      <i className="ri-eye-line w-4 h-4 flex items-center justify-center" />
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}